import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Loading,
  ScreenMask,
  SetDefaultWarehouseDialog,
} from 'components/common';
import { LOADING_ICON_SIZE1, LS_DEFAULT_WAREHOUSE_KEY, PoRecvStorageKey } from 'constants/config';
import { RootState } from 'reducers';
import { getStorage, getWarehouseCodeFromCache } from 'utils';
import PoInfo from './PoInfo';
import RecvPo from './RecvPo';
import ScanPo from './ScanPo';
import {
  PoRecvActionType as PRAction,
  PoRecvStep,
  initialState,
  isValidStep,
  reducer,
} from './context';

const DefaultStep = PoRecvStep.ScanPo;

const getStateFromStorage = () => {
  const state: StringKAnyVPair = {};
  const storage = getStorage('session');

  const scanRecvCountType = storage.getItem(PoRecvStorageKey.ScanRecvCountType);
  if (scanRecvCountType !== null && !isNaN(Number(scanRecvCountType))) state.scanRecvCountType = Number(scanRecvCountType);
  const scanRecvLotPolicy = storage.getItem(PoRecvStorageKey.ScanRecvLotPolicy);
  if (scanRecvLotPolicy !== null && !isNaN(Number(scanRecvLotPolicy))) state.scanRecvLotPolicy = Number(scanRecvLotPolicy);
  const scanRecvLotUniNum = storage.getItem(PoRecvStorageKey.ScanRecvLotUniNum);
  if (scanRecvLotUniNum !== null) state.scanRecvLotUniNum = scanRecvLotUniNum;
  const scanRecvRatio = storage.getItem(PoRecvStorageKey.ScanRecvRatio);
  if (scanRecvRatio !== null && !isNaN(Number(scanRecvRatio))) state.scanRecvRatio = Number(scanRecvRatio);
  const scanRecvRatioType = storage.getItem(PoRecvStorageKey.ScanRecvRatioType);
  if (scanRecvRatioType !== null && !isNaN(Number(scanRecvRatioType))) state.scanRecvRatioType = Number(scanRecvRatioType);

  return state;
};

const PoReceive = () => {
  const { useReducer, useState } = React;
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] = useState(false);
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [inited, setInited] = useState(false);
  const [profileSettingInited, setProfileSettingInited] = useState(false);

  const userProfileSettings = useSelector(
    (state: RootState) => state.admin.userProfileSettings,
    shallowEqual
  );
  const warehouseList = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );

  //const [state, dispatch] = useReducer(reducer, initialState({}));
  const [state, dispatch] = useReducer(reducer, initialState(getStateFromStorage()));

  /*const getEnablePOOverReceive = async () => {
    const res = await getProfileSettingValue('EnablePOOverReceive', '0');
    const res1 = await getProfileSettingValue('EnableLOT', '0');
    const res2 = await getProfileSettingValue('EnableUOM', '0');
    const res3 = await getProfileSettingValue('TimeZone');
    const res4 = await getProfileSettingValue('EnablePOReceiveExtra');
    setEnablePOOverReceive(res);
    setLotEnable(res1 === '1');
    setUomEnable(res2 === '1');
    setEnableExtra(res4 === '1');
    setTimeZone(res3);
    if (res1 === '1') {
      getLOTSettings();
    }
  };
     const getLOTSettings = useCallback(async () => {
    try {
      const res = await fetchLOTSettings();
      if (res.isSuccess) {
        setLotNumberGenerationType(res.data.generation);
        setNoUniqueControl(!!res.data.unique);
      }
    } catch (error) {}
  }, []);*/

  const gotoAnchor = (step: PoRecvStep) => {
    const newHash = `#${step}`;
    //const url = window.location.pathname + window.location.search + newHash;

    window.location.hash = newHash;
  };

  const onCheckoutPo = (po: StringKAnyVPair) => {
    console.log('sel', po);
    if (po.warehouseCode === state.selectedWarehouse.code) {
      //setCurrentPo(po);
      dispatch({ type: PRAction.SetCurrentPo, params: po });
      gotoAnchor(PoRecvStep.PoInfo);
    } else {
      Modal.confirm({
        cancelText: 'No',
        centered: true,
        content: 'PO warehouse doesn’t match your default warehouse, do you want to switch the warehouse?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Yes',
        onOk() {
          setDefaultWarehouseVisible(true);
        },
        //onCancel() { checkWarehouse(po); },
      });
    }
  };

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  React.useEffect(() => {
    if (!inited) {
      const whid = Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY));

      if (!whid || (typeof whid === 'number' && !getWarehouseCodeFromCache(whid))) {
        openSetDefaultWarehouseDialog({ closable: false });
      }

      const wh = warehouseList.find(w => w.id === whid);

      if (wh) {
        dispatch({ type: PRAction.SetSelectedWarehouse, params: {...wh} });
      }

      gotoAnchor(PoRecvStep.ScanPo);
      setInited(true);
    }

    if (userProfileSettings && !profileSettingInited) {
      const cwr = userProfileSettings.find(
        (e) => e.settingCode === 'CrossWarehouseReceive'
      );
      const enl = userProfileSettings.find((e) => e.settingCode === 'EnableLOT');
      const eor = userProfileSettings.find(
        (e) => e.settingCode === 'EnablePOOverReceive'
      );
      const ere = userProfileSettings.find(
        (e) => e.settingCode === 'EnablePOReceiveExtra'
      );
      const euo = userProfileSettings.find((e) => e.settingCode === 'EnableUOM');
      const mpc = userProfileSettings.find(e => e.settingCode === 'EnableMultiPurpostProductCode');
      const prp = userProfileSettings.find((e) => e.settingCode === 'POOverReceivePercentage');
      const tiz = userProfileSettings.find((e) => e.settingCode === 'TimeZone');

      //console.log('cw->', cwr, ere, eor, enl, euo, prp);
      console.log('mpc', mpc);
      setProfileSettingInited(true);

      if (cwr) dispatch({ type: PRAction.SetCrossWarehouseReceive, params: cwr.settingValue });
      if (enl) dispatch({ type: PRAction.SetEnableLot, params: enl.settingValue === '1' });
      if (eor) dispatch({ type: PRAction.SetEnablePOReceiveControl, params: eor.settingValue === '1' });
      if (ere) dispatch({ type: PRAction.SetEnablePOReceiveExtra, params: ere.settingValue });
      if (euo) dispatch({ type: PRAction.SetEnableUom, params: euo.settingValue === '1' });
      if (tiz) dispatch({ type: PRAction.SetTimeZone, params: tiz.settingValue });

      if (prp) {
        const pcn = Number(prp.settingValue) ? Number(prp.settingValue) / 100 : 0;

        dispatch({ type: PRAction.SetPoOverRecvPercent, params: pcn });
      }
    }

    const handleHashChange = () => {
      const anchor = window.location.hash.trim().slice(1) || DefaultStep;

      if (isValidStep(anchor)) {
        //console.log('ch step', anchor);
        dispatch({ type: PRAction.SetRecvStep, params: anchor });
      }
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [
    inited,
    profileSettingInited,
    userProfileSettings,
    warehouseList,
  ]);

  return (<>
    <div style={{ marginTop: 10 }}>
      {state.recvStep === PoRecvStep.ScanPo && (
        <ScanPo
          dispatch={dispatch}
          onSelectPo={onCheckoutPo}
          state={state}
        />
      )}
      {state.recvStep === PoRecvStep.PoInfo && (
        <PoInfo
          dispatch={dispatch}
          gotoAnchor={gotoAnchor}
          state={state}
        />
      )}
      {state.recvStep === PoRecvStep.RecvPo && (
        <RecvPo
          dispatch={dispatch}
          gotoAnchor={gotoAnchor}
          state={state}
        />
      )}
    </div>
    {defaultWarehouseVisible && (
      <SetDefaultWarehouseDialog
        closable={dialogClosable}
        close={() => {
          setDefaultWarehouseVisible(false);
        }}
        visible={defaultWarehouseVisible}
      />
    )}
    {state.lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default PoReceive;

export const findMatchItemList = (
  recvItems: StringKAnyVPair[],
  itemCode: string,
): StringKAnyVPair[] => {
  return recvItems.filter(e => isCodeMatchLine(itemCode, e));
};

export const findMatchProductCode = (
  codeStr: string,
  prd: StringKAnyVPair,
) => {
  const code = codeStr.trim().toLowerCase();
  let ret: StringKAnyVPair | undefined = undefined;

  if (Array.isArray(prd.productCodes)) {
    ret = prd.productCodes.find((e: StringKAnyVPair) => {
      if (e && typeof e === 'object' && typeof e.code === 'string') {
        return e.code.trim().toLowerCase() === code;
      }

      return false;
    });
  }

  return ret;
};

export const getMatchItemBaseQty = (
  recvItems: StringKAnyVPair[],
  itemCode: string,
) => {
  return findMatchItemList(recvItems, itemCode).reduce((a, b) => a + b._baseQty, 0);
};

export const getItemReceivingMaxQty = (
  recvItems: StringKAnyVPair[],
  item: StringKAnyVPair,
) => {
  const cQty = item._receivingQty || 0;
  const nQty = getMatchItemReceivingQty(recvItems, item.sku || item.upc);
  const rQty = item.poQty - item.humanReceiveQty - (nQty - cQty);

  return rQty > 0 ? rQty : 0;
};

export const getMatchItemReceivingQty = (
  recvItems: StringKAnyVPair[],
  itemCode: string,
) => {
  return findMatchItemList(recvItems, itemCode).reduce((a, b) => a + b._receivingQty, 0);
};

export const isCodeMatchLine = (codeStr: string, e: StringKAnyVPair) => {
  const trimCode = codeStr.trim();
  const code = trimCode.toLowerCase();

  //return (e.sku.toLowerCase() === code || e.upc.toLowerCase() === code || isCodeValid(trimCode, e.codes));
  //console.log('m->', code, e.productCodes);
  return (e.sku.toLowerCase() === code || e.upc.toLowerCase() === code || !!findMatchProductCode(code, e));
};

export const isLotAvailableOnItem = (
  state: StringKAnyVPair,
  item: StringKAnyVPair,
) => {
  //return state.enableLot;
  return state.enableLot && item.lotControl === 1;
};
